import './style.css';

import { Dialog } from '@economic/taco';
import React, { useState } from 'react';
import { UnexpectedError } from '@economic/react-app';

export function ErrorDialog({ onClose }: { onClose?: Function }) {
    const [show, setShow] = useState(true);
    if (!show) {
        return null;
    }

    function close() {
        setShow(false);
        onClose?.();
    }

    return (
        <Dialog defaultOpen onClose={close}>
            <Dialog.Content aria-label="">
                <div className="error-modal-container">
                    <UnexpectedError />
                </div>
            </Dialog.Content>
        </Dialog>
    );
}
